<ng-template #content role="document" let-modal>
  <div class="modal-header bg-primary rounded">
    <div class="col">
      <h5 *ngIf="!property || !property?.title" class="modal-title text-white" id="userModalLabel">
        {{'t-m-properties.'+textAddOrUpdateModalTitle | translate}}
      </h5>
      <h5 *ngIf="property && property?.title" class="modal-title text-white" id="userModalLabel">
        {{'t-m-properties.'+textAddOrUpdateModalTitle | translate}} - {{property.title}}
        <!-- Revenda: criada a partir de uma fração ("Criar revenda"). -->
        <span *ngIf="propertyUpdate?.isResale || property?.isResale" class="badge badge-soft-warning fs-12 ms-2 align-middle">
          {{ (propertyUpdate?.resaleOf?.reference || property?.resaleOf?.reference)
            ? ('t-resale-of' | translate:{ reference: (propertyUpdate?.resaleOf?.reference || property?.resaleOf?.reference) })
            : ('t-resale' | translate) }}
        </span>
      </h5>
    </div>

    <div class="col-lg-8 m-n2 rounded" [ngClass]="{'d-none':warningSubject$.getValue() === 0 ||
       (!permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') 
       && property && !permissionsService.canEditProperty(loginUser, property?.store?.id))}">
      <div class="dropdown pe-3 float-end" ngbDropdown>
        <button type="button" class="btn btn-icon rounded-circle border border-dashed border-white position-relative 
          d-flex align-items-center justify-content-center" ngbDropdownToggle>
          <i class="bx bx-error fs-22 text-white"></i>

          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fs-10">
            {{ warningSubject$.getValue() }}

            <span class="visually-hidden">{{ 't-info' | translate }}</span>
          </span>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu>
          <div class="dropdown-head bg-soft-danger rounded-top">
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0 fs-16 fw-semibold text-danger"> {{'t-info' | translate}} </h6>
                </div>

                <div class="col-auto dropdown-tabs">
                  <span class="badge bg-danger fs-13 text-white rounded-circle">
                    {{warningSubject$.getValue()}}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Placement Offcanvas WARNING -->
          <div class="card-body">
            <ngx-simplebar class="px-3 mx-n3 mb-2" [ngStyle]="{ 'height.vh': 67 }" [options]="{ forceVisible: true }">
              <h6 class="fs-15" *ngIf="!canActivateProperties.available">{{'t-validation.t-general' | translate}}</h6>

              <ng-container *ngIf="!canActivateProperties.available">
                <div class="d-flex mt-2 mb-4">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill text-warning"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p [innerHTML]="authService.currentUserValue.role?.name === 'MASTER' ? ('t-validation.t-properties-limit' | translate) : ('t-validation.t-properties-limit-agent' | translate)"
                      class="text-muted mb-0">
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="detailsForm?.errors?.length > 0">{{'t-details' | translate}}</h6>

              <ng-container *ngFor="let error of detailsForm?.errors; index as i">
                <div class="d-flex mt-2 mb-4" *ngIf="error.type?.warning && error.key === 'reference'">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill" [ngClass]="{'text-danger':error.type?.warning}"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0">
                      {{'t-m-properties.t-info-key-form.t-' + error.key | translate}}
                      {{'t-exist' | translate}}
                    </p>
                  </div>
                </div>

                <div class="d-flex mt-2 mb-4">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{'text-warning':error.type?.warning, 'text-danger':error.type?.required}"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="error.type?.warning">
                      {{'t-m-properties.t-info-key-form.t-' + error.key | translate}}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>

                    <p class="text-muted mb-0" *ngIf="error.type?.required">
                      {{'t-m-properties.t-info-key-form.t-' + error.key | translate}}
                      {{'t-m-properties.t-is-mandatory-to-save-and-activate-the-property' | translate}}
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="addressForm?.errors?.length > 0">
                {{'t-m-properties.t-address' | translate}}
              </h6>

              <ng-container *ngFor="let error of addressForm?.errors; index as i">
                <div class="d-flex mt-2 mb-4">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{'text-warning':error.type?.warning, 'text-danger':error.type?.required}"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="error.type?.warning">
                      {{'t-' + error.key | translate }}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="propertyAreasNearbyData?.errors?.length > 0">
                {{'t-m-properties.t-areas' | translate}}
              </h6>

              <ng-container *ngFor="let error of propertyAreasNearbyData?.errors; index as i">
                <div class="d-flex mt-2 mb-4">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{'text-warning':error.type?.warning, 'text-danger':error.type?.required}"></i>
                  </div>

                  <div class="flex-grow-1 ms-2" *ngIf="error.key !== 'divisions'">
                    <p class="text-muted mb-0" *ngIf="error.type?.warning">
                      {{'t-m-properties.t-info-key-form.t-' + error.key | translate }}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                  </div>

                  <div class="flex-grow-1 ms-2" *ngIf="error.key === 'divisions'">
                    <p class="text-muted mb-0" *ngIf="error.type?.warning">
                      {{'t-divisions-min-required' | translate}},
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="propertyMultimediaData?.errors?.length > 0">
                {{'t-m-properties.t-multimedia' | translate }}
              </h6>

              <ng-container *ngIf="propertyMultimediaData?.errors?.length > 0">
                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill text-warning"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0">
                      {{'t-multimedia-min-required' | translate }},
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                  </div>
                </div>

                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill text-warning"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0">
                      {{'t-m-properties.t-images_or_videos_must_also_be_activated' | translate }}
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="propertyAdvertisementData?.errors?.length > 0">
                {{ 't-m-properties.t-advertisement' | translate }}
              </h6>

              <ng-container *ngFor="let error of propertyAdvertisementData?.errors; index as i">
                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{'text-warning': error.type?.warning,'text-danger': error.type?.required}"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="error.type?.warning || error.type?.required">
                      <ng-container [ngSwitch]="error.key">
                        <ng-container *ngSwitchCase="'title'">
                          {{ 't-title' | translate }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'description'">
                          {{ 't-description' | translate }}
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                          {{ ('t-' + error.key) | translate }}
                        </ng-container>
                      </ng-container>

                      {{ 't-m-properties.t-is-mandatory-to-activate-the-property' | translate }}
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="propertyOwnersContactsData?.errors?.length > 0">
                {{'t-m-properties.t-contacts' | translate }}
              </h6>

              <ng-container *ngIf="propertyOwnersContactsData?.errors?.length">
                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{'text-warning': propertyOwnersContactsData?.errors[0].type?.warning}"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="propertyOwnersContactsData?.errors[0].type?.warning">
                      {{'t-required-owner' | translate }}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="propertyDocumentsData?.errors?.length > 0">
                {{'t-m-properties.t-documents' | translate }}
              </h6>

              <ng-container *ngIf="propertyDocumentsData?.errors?.length > 0">
                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill text-warning"></i>
                  </div>

                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="hasDocumentsError('documents.mediaMin')">
                      {{'t-documents-min-required' | translate }},
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                    <p class="text-muted mb-0" *ngIf="hasDocumentsError('documents.types')">
                      {{ 't-property-docs-warning-missing' | translate:{ names: documentsMissingTypeNames() } }},
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                  </div>
                </div>
              </ng-container>
            </ngx-simplebar>
          </div>
        </div>
      </div>
    </div>

    <div class="col-auto mt-2">
      <button type="button" class="btn-close btn-close-white" aria-label="Close" id="close-modal"
        (click)="modal.dismiss('Cross click')">
      </button>
    </div>
  </div>

  <div class="modal-body pt-0 rounded">
    <input type="hidden" id="id-field" />

    <!-- AI suggestion banner: shown for new properties when the entity has the
         doc-extraction service activated. Dismissable; clicking the CTA opens
         the wizard as an overlay so the form stays visible underneath. -->
    <div class="ai-suggest-banner" *ngIf="aiExtractionAvailable && !property && !aiBannerDismissed && !aiPanelOpen">
      <div class="ai-suggest-banner__icon"><i class="bx bx-bot"></i></div>
      <div class="ai-suggest-banner__body">
        <strong>{{ 'ai-doc-wizard.banner.title' | translate }}</strong>
        <span class="ai-suggest-banner__desc">{{ 'ai-doc-wizard.banner.desc' | translate }}</span>
      </div>
      <button type="button" class="btn btn-primary btn-sm ai-suggest-banner__cta" (click)="openAiPanel()">
        <i class="ri-sparkling-2-fill me-1"></i>{{ 'ai-doc-wizard.banner.cta' | translate }}
      </button>
      <button type="button" class="btn-close ai-suggest-banner__close"
        aria-label="Dispensar" (click)="dismissAiBanner()"></button>
    </div>

    <!-- Extração de documentos com IA: abre por cima do formulário, em imóveis
         novos e existentes. Só existe com o serviço ativo para o utilizador. -->
    <div class="ai-extraction-entry" *ngIf="aiExtractionAvailable && property && !aiPanelOpen">
      <button type="button" class="btn btn-soft-primary btn-sm" (click)="openAiPanel()">
        <i class="ri-sparkling-2-fill me-1"></i>{{ 'ai-extraction.entry' | translate }}
      </button>
    </div>

    <app-ai-extraction-panel *ngIf="aiPanelOpen"
      [propertyId]="property?.id || null"
      [lookups]="aiLookups"
      [currentValues]="aiCurrentValues"
      [propertyFileIds]="aiPanelPropertyFileIds"
      (applied)="onAiExtractionApplied($event)"
      (closed)="closeAiPanel()">
    </app-ai-extraction-panel>

    <!-- `aiRemountingTabs` só fica a true durante a aplicação de valores da
         extração com IA. A lista de separadores e o conteúdo têm de ser criados
         juntos, por isso o que se desmonta é este bloco inteiro e nunca só o
         conteúdo. -->
    <div class="row" *ngIf="openModaltSubject$.value === 6 && !aiRemountingTabs">
      <div class="card-header pt-0 px-0">
        <ul ngbNav #customNav="ngbNav" [(activeId)]="nabTabActive" (activeIdChange)="activeIdChangeNabTab()"
          class="nav nav-pills nav-custom-outline nav-primary rounded card-header-tabs border-bottom-0 p-3"
          role="tablist">
          <!-- class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist"> -->
          <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link">
              {{'t-m-properties.t-details' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="(this.detailsForm?.errors?.length>0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
               || (this.detailsForm?.errors?.length>0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
               || (this.detailsForm?.errors?.length>0 && !property)">

                {{this.detailsForm?.errors?.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-details [allAgents]="dataToFormInitAgents" [submitted]="submitted" [detailsForm]="detailsForm"
                [quantityAvailable]="canActivateProperties.quantity" [dataToFormInitDetails]="dataToFormInitDetails"
                [property]="property" [propertyAgentsData]="propertyAgentsData"
                [canChangeBusinessStatus]="canChangeBusinessStatus" [isUpdate]="isUpdate"
                [prospectingId]="prospectingId" [minimumCommissionValidation]="minimumCommissionValidation"
                (agentsChange)="propertyAgentsData = $event"></app-details>
            </ng-template>
          </li>

          <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link">
              {{'t-m-properties.t-address' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="(this.addressForm?.errors?.length>0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
              || (this.addressForm?.errors?.length>0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
              || (this.addressForm?.errors?.length>0 && !property)">

                {{this.addressForm?.errors?.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-address [submitted]="submitted" [addressForm]="addressForm"
                [dataToFormInitAddress]="dataToFormInitAddress" [property]="property"
                [stores]="dataToFormInitDetails?.stores" [selectedStore]="detailsForm?.data?.store">
              </app-address>
            </ng-template>
          </li>

          <li [ngbNavItem]="3" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="far fa-envelope"></i>
              {{'t-m-properties.t-areas' | translate }}/{{'t-m-properties.t-nearby' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="(this.propertyAreasNearbyData?.errors?.length>0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
              || (this.propertyAreasNearbyData?.errors?.length>0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
              || (this.propertyAreasNearbyData?.errors?.length>0 && !property)">

                {{this.propertyAreasNearbyData?.errors?.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-areas-nearby [submitted]="submitted" [propertyAreasNearbyData]="propertyAreasNearbyData"
                [dataToFormInit]="dataToFormInitAreasNearby" [detailsForm]="detailsForm"
                [dataToFormInitDetails]="dataToFormInitDetails" [property]="property">
              </app-areas-nearby>
            </ng-template>
          </li>

          <li [ngbNavItem]="4" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="far fa-envelope"></i>
              {{'t-m-properties.t-charateristics' | translate }}
            </a>

            <ng-template ngbNavContent>
              <app-charateristics [submitted]="submitted" [dataToFormInitChar]="dataToFormInitChar"
                [propertyCharateristicsData]="propertyCharateristicsData" [property]="property"
                [detailsForm]="detailsForm" [dataToFormInitDetails]="dataToFormInitDetails">
              </app-charateristics>
            </ng-template>
          </li>

          <li [ngbNavItem]="6" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-multimedia' | translate }}
              <span class="badge bg-danger rounded-circle"
                *ngIf="(this.propertyMultimediaData?.errors?.length>0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property))
                || (this.propertyMultimediaData?.errors?.length>0 && permissionsService.canEditProperty(loginUser, property?.store?.id))
                || (this.propertyMultimediaData?.errors?.length>0 && !property)">{{this.propertyMultimediaData?.errors?.length}}</span>
            </a>

            <ng-template ngbNavContent>
              <app-multimedia [propertyMultimediaData]="propertyMultimediaData" [property]="property"></app-multimedia>
            </ng-template>
          </li>

          <li [ngbNavItem]="5" class="nav-item">
            <a ngbNavLink class="nav-link">
              {{'t-m-properties.t-advertisement' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="(propertyAdvertisementData?.errors?.length > 0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
                || (propertyAdvertisementData?.errors?.length > 0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
                || (propertyAdvertisementData?.errors?.length > 0 && !property)">

                {{propertyAdvertisementData?.errors?.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-advertisement1 [submitted]="submitted" [dataToFormInitAdvertisement]="dataToFormInitAdvertisement"
                [dataToFormInitAreasNearby]="dataToFormInitAreasNearby" [dataToFormInitChar]="dataToFormInitChar"
                [propertyAdvertisementData]="propertyAdvertisementData" [isActive]="warningSubject$"
                [property]="property" [propertyAreasNearbyData]="propertyAreasNearbyData"
                [propertyCharateristicsData]="propertyCharateristicsData">
              </app-advertisement1>
            </ng-template>
          </li>

          <li [ngbNavItem]="7" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-agents' | translate }}
            </a>

            <ng-template ngbNavContent>
              <app-agents [dataToFormInitAgents]="dataToFormInitAgents" [propertyAgentsData]="propertyAgentsData"
                [property]="property" [detailsForm]="detailsForm" [dataToFormInitDetails]="dataToFormInitDetails"
                [isUpdate]="isUpdate"></app-agents>
            </ng-template>
          </li>

          <!-- Com PROPERTY_OWNERS alargado à entidade a tab abre em leitura: os botões de adicionar/editar/remover lá dentro continuam gated por permissão de edição. -->
          <li [ngbNavItem]="8" class="nav-item"
            *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property || permissionsService.hasEntityDataScope('PROPERTY_OWNERS')">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-contacts' | translate }}

              <span class="badge bg-danger rounded-circle" *ngIf="(propertyOwnersContactsData?.errors?.length > 0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') && property)) 
                || (propertyOwnersContactsData?.errors?.length > 0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
                || (propertyOwnersContactsData?.errors?.length > 0 && !property)">
                {{this.propertyOwnersContactsData?.errors?.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-contacts [submitted]="submitted" [propertyCostumersContactsData]="propertyCostumersContactsData"
                [propertyOwnersContactsData]="propertyOwnersContactsData" [propertyId]="propertyId"
                [requiredOwner]="requiredOwner" [property]="property"></app-contacts>
            </ng-template>
          </li>

          <li [ngbNavItem]="9" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-portals' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="portalsLogs && portalsLogs > 0">{{portalsLogs}}</span>
            </a>

            <ng-template ngbNavContent>
              <app-portals [dataToFormInitPortals]="dataToFormInitPortals" [propertyPortalsData]="propertyPortalsData"
                [propertyId]="propertyId" [property]="property"
                [dataToFormInitDetails]="dataToFormInitDetails"></app-portals>
            </ng-template>
          </li>

          <li [ngbNavItem]="10" class="nav-item">
            <a ngbNavLink class="nav-link">

              <i class="fas fa-home"></i>
              {{'t-m-properties.t-documents' | translate }}

              <span class="badge bg-danger rounded-circle" *ngIf="(propertyDocumentsData?.errors?.length > 0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
                || (propertyDocumentsData?.errors?.length > 0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
                || (propertyDocumentsData?.errors?.length > 0 && !property)">
                {{propertyDocumentsData?.errors?.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-documents
                [propertyDocumentsData]="propertyDocumentsData"
                [property]="property"
                [detailsForm]="detailsForm"
                [aiExtractionAvailable]="aiExtractionAvailable"
                (aiExtractRequested)="openAiPanel($event)"
                (aiDocExtracted)="onWizardExtracted($event)">
              </app-documents>
            </ng-template>
          </li>

          <li [ngbNavItem]="11" *ngIf="property && permissionsService.hasPermission('VIEW_PROPOSALS')" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-proposals' | translate }}
            </a>

            <ng-template ngbNavContent>
              <app-proposals [openProposal]="openProposal" [typeRent]="dataToFormInitDetails?.typeRent"
                [statusList]="statusList" [agents]="dataToFormInitAgentsDetails" [allAgents]="dataToFormInitAgents"
                [detailsForm]="detailsForm" [propertyProposalsData]="propertyProposalsData" [dataToFormInitDetails]="dataToFormInitDetails"
                [property]="property"(agentsChange)="propertyAgentsData = $event" [propertyAgentsData]="propertyAgentsData"></app-proposals>
            </ng-template>
          </li>

          <li [ngbNavItem]="12" *ngIf="property && propertyReviewData" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-reviews' | translate }}
            </a>

            <ng-template ngbNavContent>
              <app-visit-reviews [property]="property" [propertyAgentsData]="propertyAgentsData"
                [propertyReviewData]="propertyReviewData"></app-visit-reviews>
            </ng-template>
          </li>

          <li [ngbNavItem]="13" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-mediation-tab' | translate }}

              <span class="badge bg-danger rounded-circle" *ngIf="(propertyCmiData?.errors?.length > 0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') && property))
                || (propertyCmiData?.errors?.length > 0 && permissionsService.canEditProperty(loginUser, property?.store?.id))
                || (propertyCmiData?.errors?.length > 0 && !property)">
                {{propertyCmiData?.errors?.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-mediation-contract [property]="property" [isProperty]="true"
                [storeId]="detailsForm?.data?.store"
                [isTempReference]="detailsForm?.data?.isTempReference === true"
                (referenceAssigned)="onCmiReferenceAssigned()"></app-mediation-contract>
            </ng-template>
          </li>
        </ul>
      </div>

      <div class="card-body" [ngClass]="{'minimum-commission-readonly': isMinimumCommissionReviewLockedForCurrentUser(),
        'validated-readonly': isValidatedEditLockedForCurrentUser()}">
        <div class="tab-content" [appAiProvenance]="aiProvenanceSources">
          <!-- <ngx-simplebar class="px-3 mx-n3 mb-2"
                        style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
                        [options]="{ forceVisible: true }"> -->
          <div [ngbNavOutlet]="customNav"></div>
          <!-- </ngx-simplebar> -->
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>

  <!-- footer -->
  <div
    class="modal-footer d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between flex-wrap">
    <div *ngIf="currentProperty?.id" class="d-flex align-items-center gap-3 text-center text-md-start flex-wrap">
      <div>
        {{ 't-m-properties.t-updated-at' | translate }} :

        <span class="fw-medium">
          {{ createDateFormat(currentProperty.updated) }}
        </span>
      </div>

      <div class="vr d-none d-md-block"></div>

      <div>
        {{ 't-m-properties.t-status' | translate }} :

        <span class="badge rounded-pill fs-12"
          [ngClass]="{
          'badge-soft-success': ['AVAILABLE','ACTIVE'].includes(currentProperty?.details?.businessStatusData?.code),
          'badge-soft-warning': ['PROSPECTING','CPCV', 'NO_ATTENTION', 'DRAFT'].includes(currentProperty?.details?.businessStatusData?.code),
          'badge-soft-info': ['RESERVED','DEED', 'TO_VALIDATE', 'RENTED'].includes(currentProperty?.details?.businessStatusData?.code),
          'badge-soft-danger' : ['DECLINED','CANCELED','REMOVED','SOLD'].includes(currentProperty?.details?.businessStatusData?.code)}">
          {{ (currentProperty?.details?.businessStatusData?.name) | translate }}
        </span>
      </div>
    </div>

    <!-- Botões e alertas (hidden during wizard) -->
    <div class="hstack gap-2 mt-3 mt-md-0 ms-md-auto" id="btn-property-modal-footer">
      <button class="btn btn-light d-none" id="btn-property-warning" type="button" data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"></button>

      <!-- ⚠️ REJEIÇÃO (somente AGENT) -->
      <div *ngIf="permissionsService.isAgent(user?.role?.name)
        && currentProperty?.details?.businessStatusData?.code === 'DECLINED'
        && currentProperty?.reviewMessage" class="alert alert-warning d-flex align-items-start gap-2 mb-0">
        <i class="ri-error-warning-line fs-4 text-warning"></i>

        <div>
          <strong>{{ 't-property-rejected-alert-title' | translate }}: </strong>
          <p class="mb-0">{{ currentProperty?.reviewMessage }}</p>
        </div>
      </div>

      <!-- ⏳ AGUARDANDO APROVAÇÃO (somente AGENT) -->
      <div *ngIf="permissionsService.isAgent(user?.role?.name) && !permissionsService.hasPermission('APPROVE_PROPERTIES')
        && currentProperty?.details?.businessStatusData?.code === 'TO_VALIDATE'"
        class="alert alert-info d-flex align-items-center gap-2 mb-0">
        <i class="ri-time-line fs-4 text-info"></i>

        <div>
          <strong>{{ 't-property-awaiting-approval' | translate }}</strong>
          <p class="mb-0">{{ 't-property-awaiting-approval-text' | translate }}</p>
        </div>
      </div>

      <!-- 🔒 IMÓVEL VALIDADO — MODO CONSULTA (sem permissão EDIT_PROPERTIES_AFTER_VALIDATION) -->
      <div *ngIf="isValidatedEditLockedForCurrentUser()" class="alert alert-info d-flex align-items-center gap-2 mb-0">
        <i class="ri-lock-line fs-4 text-info"></i>

        <div>
          <p class="mb-0">{{ 't-property-validated-readonly' | translate }}</p>
        </div>
      </div>

      <!-- ✅ APROVADO (somente AGENT) -->
      <div *ngIf="showApprovedAlert" class="alert alert-success d-flex align-items-center gap-2 mb-0">
        <i class="ri-checkbox-circle-line fs-4 text-success"></i>

        <div>
          <strong>{{ 't-property-approved' | translate }}</strong>
          <p class="mb-0">{{ 't-property-approved-text' | translate }}</p>
        </div>
      </div>

      <!-- FECHAR -->
      <button type="button" class="btn btn-soft-dark waves-effect waves-light" *ngIf="!shouldShowApproveButton()
        && !shouldShowRejectButton() && currentProperty?.details?.businessStatusData?.code !== 'TO_VALIDATE'"
        data-bs-dismiss="modal" (click)="modal.close('Close click')">
        {{ 't-close' | translate }}
      </button>

      <!-- SALVAR (sempre visível em CREATE; em EDIT some se estiver 'TO_VALIDATE') -->
      <button type="button" class="btn btn-primary" id="add-btn" (click)="saveProperty()"
        [attr.disabled]="requiredSubject$.getValue() ? true : null" *ngIf="canSaveProperty()">
        {{ textAddOrUpdateModal | translate }}<span
          *ngIf="!warningSubject$.getValue() && !requiredSubject$.getValue() && (shouldShowValidateButton() || shouldShowGenerateRefButton())">
          {{'t-draft' | translate}}
        </span>
      </button>

      <!-- VALIDAR (somente AGENT) -->
      <button type="button"
        *ngIf="!warningSubject$.getValue() && !requiredSubject$.getValue() && shouldShowValidateButton()"
        class="btn btn-warning" (click)="saveProperty(false, true)">
        {{ 't-validate-property' | translate }}
      </button>

      <!-- REFERÊNCIA: só exige a ficha base (sem CMI, multimédia, documentos) -->
      <button type="button" [ngbTooltip]="'t-generate-reference-tooltip' | translate" placement="top" container="body"
        *ngIf="!property && !baseWarningSubject$.getValue() && !requiredSubject$.getValue() && shouldShowGenerateRefButton()"
        class="btn btn-soft-info" (click)="saveProperty(false, false, true)">
        {{ 't-save-and-generate-reference' | translate }}
      </button>

      <!-- Imóvel existente: gate do próprio formulário (avisos da ficha base) -->
      <button type="button" [ngbTooltip]="'t-generate-reference-tooltip' | translate" placement="top" container="body"
        *ngIf="property && !baseWarningSubject$.getValue() && !requiredSubject$.getValue() && shouldShowGenerateRefButton()"
        class="btn btn-soft-info" (click)="generateReference()">
        {{ 't-generate-reference' | translate }}
      </button>

      <!-- APROVAR -->
      <span [ngbTooltip]="'t-approve-property-tooltip' | translate" container="body" placement="top" [openDelay]="200">
        <button type="button" class="btn btn-outline-success" *ngIf="shouldShowApproveButton() && !isMinimumCommissionReviewLockedForCurrentUser()"
          (click)="approveProperty()">
          {{ 't-approve-property' | translate }}
        </button>
      </span>

      <!-- REJEITAR -->
      <span [ngbTooltip]="'t-reject-property-tooltip' | translate" container="body" placement="top" [openDelay]="200">
        <button type="button" class="btn btn-outline-danger" *ngIf="shouldShowRejectButton() && !isMinimumCommissionReviewLockedForCurrentUser()"
          (click)="openRejectModal()">
          {{ 't-reject-property' | translate }}
        </button>
      </span>
    </div>
  </div>

  <!-- Placement Offcanvas SAVE -->
  <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header p-0">
      <div class="alert alert-danger alert-dismissible alert-additional fade show mb-0" role="alert">
        <div class="alert-body">
          <div class="d-flex">
            <div class="flex-shrink-0 me-3">
              <i class="ri-alert-line fs-16 align-middle"></i>
            </div>

            <div class="flex-grow-1">
              <h5 class="alert-heading">{{'t-are-you-sure-you-want-to-save' | translate}}</h5>

              <p class="mb-0">{{'t-some-fields-are-not-filled-in' | translate}}</p>
            </div>
          </div>
        </div>

        <div class="alert-content border-0" style="border-radius: 0;">
          <p class="mb-0">
            {{'t-m-properties.t-the-following-fields-are-mandatory-to-activate-the-property' | translate}}
          </p>
        </div>
      </div>
      <!-- <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
    </div>

    <div class="offcanvas-body">
      <h6 class="fs-15" *ngIf="!canActivateProperties.available">{{'t-validation.t-general' | translate}}</h6>

      <ng-container *ngIf="!canActivateProperties.available">
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p [innerHTML]="authService.currentUserValue.role?.name === 'MASTER' ? 
            ('t-validation.t-properties-limit' | translate) : ('t-validation.t-properties-limit-agent' | translate)"
              class="text-muted mb-0">
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="detailsForm?.errors?.length > 0">{{'t-details' | translate}}</h6>

      <ng-container *ngFor="let error of detailsForm?.errors; index as i">
        <div class="d-flex mt-2 mb-4" *ngIf="error.type?.warning && error.key === 'reference'">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill" [ngClass]="{'text-danger':error.type?.warning}"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0">
              {{'t-m-properties.t-info-key-form.t-' + error.key | translate}}
              {{'t-exist' | translate}}
            </p>
          </div>
        </div>

        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill"
              [ngClass]="{'text-warning':error.type?.warning, 'text-danger':error.type?.required}"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0" *ngIf="error.type?.warning">
              {{'t-m-properties.t-info-key-form.t-' + error.key | translate}}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>

            <p class="text-muted mb-0" *ngIf="error.type?.required">
              {{'t-m-properties.t-info-key-form.t-' + error.key | translate}}
              {{'t-m-properties.t-is-mandatory-to-save-and-activate-the-property' | translate}}
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="addressForm?.errors?.length > 0">
        {{'t-m-properties.t-address' | translate}}
      </h6>

      <ng-container *ngFor="let error of addressForm?.errors; index as i">
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill"
              [ngClass]="{'text-warning':error.type?.warning, 'text-danger':error.type?.required}"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0" *ngIf="error.type?.warning">
              {{'t-' + error.key | translate}}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>

            <p class="text-muted mb-0" *ngIf="error.type?.required">
              {{'t-' + error.key | translate}}
              {{'t-m-properties.t-is-mandatory-to-save-and-activate-the-property' | translate}}
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="propertyAreasNearbyData?.errors?.length > 0">
        {{'t-m-properties.t-areas' | translate}}
      </h6>

      <ng-container *ngFor="let error of propertyAreasNearbyData?.errors; index as i">
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill"
              [ngClass]="{'text-warning':error.type?.warning, 'text-danger':error.type?.required}"></i>
          </div>

          <div class="flex-grow-1 ms-2" *ngIf="error.key !== 'divisions'">
            <p class="text-muted mb-0" *ngIf="error.type?.warning">
              {{'t-m-properties.t-info-key-form.t-' + error.key | translate }},
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>
          </div>

          <div class="flex-grow-1 ms-2" *ngIf="error.key === 'divisions'">
            <p class="text-muted mb-0" *ngIf="error.type?.warning">
              {{'t-divisions-min-required' | translate}},
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="propertyMultimediaData?.errors?.length > 0">
        {{'t-m-properties.t-multimedia' | translate }}
      </h6>

      <ng-container *ngIf="propertyMultimediaData?.errors?.length > 0">
        <div class="d-flex mt-2 mb-3">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0">
              {{'t-multimedia-min-required' | translate }}
              {{ 't-m-properties.t-is-mandatory-to-activate-the-property' | translate }}
            </p>
          </div>
        </div>

        <div class="d-flex mt-2 mb-3">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0">
              {{'t-m-properties.t-images_or_videos_must_also_be_activated' | translate }}
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="propertyAdvertisementData?.errors?.length > 0">
        {{ 't-m-properties.t-advertisement' | translate }}
      </h6>

      <ng-container *ngFor="let error of propertyAdvertisementData?.errors; index as i">
        <div class="d-flex mt-2 mb-3">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill"
              [ngClass]="{'text-warning': error.type?.warning,'text-danger': error.type?.required}"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0" *ngIf="error.type?.warning || error.type?.required">
              <ng-container [ngSwitch]="error.key">
                <ng-container *ngSwitchCase="'title'">
                  {{ 't-title' | translate }}
                </ng-container>

                <ng-container *ngSwitchCase="'description'">
                  {{ 't-description' | translate }}
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{ ('t-' + error.key) | translate }}
                </ng-container>
              </ng-container>

              {{ 't-m-properties.t-is-mandatory-to-activate-the-property' | translate }}
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="propertyOwnersContactsData?.errors?.length > 0">
        {{'t-m-properties.t-contacts' | translate}}
      </h6>

      <ng-container *ngIf="propertyOwnersContactsData?.errors?.length > 0">
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0">
              {{'t-required-owner' | translate }}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="propertyDocumentsData?.errors?.length > 0">
        {{'t-m-properties.t-documents' | translate }}
      </h6>

      <ng-container *ngIf="propertyDocumentsData?.errors?.length > 0">
        <div class="d-flex mt-2 mb-3">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0" *ngIf="hasDocumentsError('documents.mediaMin')">
              {{'t-documents-min-required' | translate }},
              {{ 't-m-properties.t-is-mandatory-to-activate-the-property' | translate }}
            </p>
            <p class="text-muted mb-0" *ngIf="hasDocumentsError('documents.types')">
              {{ 't-property-docs-warning-missing' | translate:{ names: documentsMissingTypeNames() } }},
              {{ 't-m-properties.t-is-mandatory-to-activate-the-property' | translate }}
            </p>
          </div>
        </div>
      </ng-container>

      <h6 class="fs-15" *ngIf="propertyCmiData?.errors?.length > 0">
        {{'t-mediation-tab' | translate }}
      </h6>

      <ng-container *ngFor="let error of propertyCmiData?.errors">
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>

          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0">
              {{'t-m-properties.t-info-key-form.t-' + error.key | translate}}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="offcanvas-footer border-top p-3 text-center">
      <div class="row">
        <div class="col-6">
          <button type="button" class="btn btn-outline-primary w-100" id="btn-warning-no" data-bs-dismiss="offcanvas">
            {{'t-m-properties.t-no' | translate}}
          </button>
        </div>

        <div class="col-6">
          <a (click)="saveProperty(true)" class="btn btn-outline-danger w-100">
            {{'t-m-properties.t-yes' | translate}}, {{'t-save' | translate}}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="propertyLoader" [ngClass]="{'d-none':!isSave}">
    <div class="avatar-sm spinner-border text-primary" role="status">
      <span class="visually-hidden">{{'t-loading' | translate}}</span>
    </div>
  </div>

  <div class="propertyLoader2 d-none">
    <div class="avatar-sm spinner-border text-primary" role="status">
      <span class="visually-hidden">{{'t-loading' | translate}}</span>
    </div>

    <div class="fs-14 ps-3 text-primary" role="status">
      <span>{{'t-generating-new-reference'|translate}}...</span>
    </div>
  </div>
</ng-template>
